import {
  ListItemText as MuiListItemText,
  type ListItemTextProps as MuiListItemTextProps
} from '@mui/material';

export type ListItemTextProps = MuiListItemTextProps;

export const ListItemText = (props: Readonly<ListItemTextProps>) => <MuiListItemText {...props} />;
